import axios from 'axios';

export const getHomeSettings = async () => {
    try {
        const response = await axios.get('/api/home-settings');
        return response.data;
    } catch (error) {
        console.error('Error fetching home settings:', error);
        throw error;
    }
};
